export default __webpack_public_path__ + "static/media/regulatory--no-two-stage-right-turn-for-mopeds--g1.6b816a0e.png";